<template>
  <b-sidebar
    :visible="true"
    :class="{ 'collapsed': collapsed }"
    no-header
    no-close-on-esc
    no-close-on-backdrop
    no-close-on-route-change
  >
    <div class="py-5">
      <div
        @click="$emit('onClickMyPage')"
        class="user-information clickable"
      >
        <proa-avatar
          :src="user.meta.avatar || require('@/assets/images/avatar_default.png')"
        />
        <div class="d-none d-lg-block display-name">{{ user.meta.displayName }}</div>
        <div
          v-if="user.meta.userPresence == 'online'"
          class="presence-icon"
        >
          <user-status-icon
            :user="user"
            :responsiveIcon="!collapsed && $mq === 'md'"
            :collapsed="collapsed"
          />
        </div>
      </div>
      <ul class="navigation-list">
        <li
          v-for="menu in menus"
          :key="menu.name"
          :class="{ 'active': currentMenu === menu.name, 'clickable': $route.name !== menu.name }"
          @click="$emit('onClickNextMenu', menu.name)"
        >
          <img
            v-if="currentMenu === menu.name"
            :src="require(`@/assets/images/menu_icons/${menu.name}Active.png`)"
            class="img-menu-icon"
          />
          <img
            v-else
            :src="require(`@/assets/images/menu_icons/${menu.name}.png`)"
            class="img-menu-icon"
          />
          <span class="d-none d-lg-block">{{ $t(`common.menus.${menu.name}`) }}</span>
        </li>
      </ul>
    </div>
    <template v-slot:footer>
      <div class="organization">
        <div v-if="!collapsed" class="organization-name d-none d-lg-block">{{ currentOrganizationName }}</div>
        <proa-button
          v-if="enabledChangeOrganization"
          @click.native="$emit('onClickChangeOrganization')"
        >
          <div v-if="!collapsed" class="d-none d-lg-block text-left">
            <img
              :src="require(`@/assets/images/menu_icons/changeOrganization.png`)"
              class="img-menu-icon mx-2"
            />
            <span>{{ $t('common.changeOrganization') }}</span>
          </div>
          <img
            :src="require(`@/assets/images/menu_icons/changeOrganization.png`)"
            class="d-block d-lg-none img-menu-icon"
          />
        </proa-button>
      </div>
      <div class="button-wrapper">
        <proa-button @click.native="$emit('onClickSignOut')" class="w-100">
          <div v-if="!collapsed" class="d-none d-lg-block text-left">
            <img
              :src="require(`@/assets/images/menu_icons/signOut.png`)"
              class="img-menu-icon mx-2"
            />
            <span>{{ $t('common.signOut') }}</span>
          </div>
          <img
            :src="require(`@/assets/images/menu_icons/signOut.png`)"
            class="d-block d-lg-none img-menu-icon"
          />
        </proa-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import userStatusIcon from '@/components/atoms/ProaUserStatusIcon'
export default {
  name: 'SideNavigation',
  components: {
    userStatusIcon
  },
  props: {
    menus: Array,
    enabledChangeOrganization: Boolean,
    collapsed: Boolean,
    currentMenu: String,
    currentOrganizationName: String,
    user: Object
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.user-information {
  position: relative;
  text-align: center;
  margin-bottom: 14px;

  img {
    width: 32px !important;
    height: 32px !important;

    @include mq(lg) {
      width: 80px !important;
      height: 80px !important;
    }
  }

  .display-name {
    font-size: 12px;
    padding: 15px 15px 0 15px;
  }

  .presence-icon {
    position: absolute;
    top: 0;
    left: 8px;
    width: 60%;
    display: block;

    @include mq(lg) {
      top: 4px;
      left: 64px;
    }
  }

}

ul.navigation-list {
  list-style: none;
  padding-top: 30px;
  padding-left: 0;

  li {
    user-select: none;
    color: $light-text-color !important;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;

    margin: 11px;
    padding: 6px;
    border-radius: 4px;

    @include mq(lg) {
      margin: 0 20px 20px 0;
      padding: 11px 17px;
      border-radius: 0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }

    &:hover {
      background-color: $background-color;
    }

    &.active {
      color: $primary-color !important;

      @include mq(lg) {
        margin: 0 20px 20px 0;
        border-left: 5px solid $primary-color;
        box-shadow: 0px 0px 4px #0000001A;

        img {
          margin-left: -5px;
        }
      }

      &:hover {
        background-color: white;
      }
    }
    span {
      flex-grow: 1;
      padding-left: 8px;
    }
  }
}

.organization,
.button-wrapper {
  button {
    font-size: 12px !important;
    color: $light-text-color !important;
    border: 0 !important;
    border-radius: 4px;
    padding: 6px;

    @include mq(lg) {
      border: 1px solid $dark-border-color !important;
    }

    &:hover {
      background-color: $background-color !important;
    }
  }
}

.organization {
  font-size: 12px;
  margin: 0 10px 10px 10px;
  text-align: center;

  &-name {
    word-break: break-all;
    margin-bottom: 10px;
  }

  button {
    @include mq(lg) {
      width: 130px;
    }
  }
}

.button-wrapper {
  margin: 0 11px 40px 11px;

  @include mq(lg) {
    width: 130px;
    margin: 0 auto 40px auto;
  }
}
</style>
